import gql from 'graphql-tag'

const query = gql`
query getRegion($id: ID!) {
	cashAssist {
		getRegion(id: $id) {
			id
	    mod_ver
	    name
	    departmentId
	  }
	}
}
`
export default query
